import { render, staticRenderFns } from "./wchartjs.vue?vue&type=template&id=60b0cefa&"
import script from "./wchartjs.vue?vue&type=script&lang=js&"
export * from "./wchartjs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports